<template lang="pug">
#CreateEditForm
  b-form(@submit.stop.prevent="onSubmit", novalidate)
    b-form-group#input-group-name(, label="Nombre", label-for="input-name")
      b-form-input#input-name(,
        v-model="form.name",
        placeholder="Nombre",
        :state="$v.$dirty ? !$v.form.name.$invalid : null"
      )
      .errors(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.name.required") Campo requerido
    b-form-group#input-group-responsableCollaborator(,
      label="Responsable",
      label-for="input-responsable"
    )
       b-form-select(
            v-model="form.responsableCollaborator"
            :state="$v.$dirty ? !$v.form.responsableCollaborator.$invalid : null"
            id="input-responsable"
            :options="getCollaborator()"
          )
          div(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.responsableCollaborator.required") Este campo es requerido
    b-form-group#input-group-expirationDate(,
      label="Día de vencimiento ",
      label-for="input-expirationDate"
    )
      b-form-input#input-expirationDate(,
        v-model="form.expirationDate",
        placeholder="Día de vencimiento",
        type="number",
        min=1,max=31,
        :state="$v.$dirty ? !$v.form.expirationDate.$invalid : null"
      )
      .errors(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.expirationDate.required") Campo requerido
        b-form-invalid-feedback(:state="$v.form.expirationDate.between") El día debe estar entre 1 y 31
    b-form-group
      b-form-checkbox#showInSummary-input(
        v-model="form.showInSummary",
        :state="$v.$dirty ? !$v.form.showInSummary.$invalid : null"
      ) Mostrar resumen
      div(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.showInSummary.required") Este campo es requerido
    .modal-footer
      b-button(@click="hideModal" variant="outline-muted") Cancelar
      b-button(type="submit") {{ action === 'create' ? 'Crear' : 'Editar' }}
</template>
<script>
import { required, minLength, between } from "vuelidate/lib/validators";
import { mapActions , mapGetters} from "vuex";
export default {
  props: [ "selectedTask", "action", "hideModal", "makeToast"],
  validations: {
    form: {
      name: { required },
      responsableCollaborator: { required },
      expirationDate: { required , between:between(1,31)},
      showInSummary: { required }
    },
  },
  data() {
    return {
      form: {
        id: this.action === "create" ? null : this.selectedTask.id,
        name: this.action === "create" ? null : this.selectedTask.name,
        responsableCollaborator: this.action === "create" ? null : this.selectedTask.responsableCollaborator.id,
        expirationDate: this.action === "create" ? null : this.selectedTask.expirationDate,
        showInSummary: this.action === "create" ? false : (this.selectedTask.showInSummary || false)
      },
    };
  },
  methods: {
    ...mapActions(["editTask", "createTask"]),
    ...mapActions('UserStore',['listUsers']),
    async onSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        const payload = this.form;
        const action =
          this.action === "create" ? this.createTask : this.editTask;
        const response = await action(payload);
        if (response.status === 200 || response.status === 201) {
          this.makeToast("success", response.data.message, "Éxito!");
          this.hideModal();
        } else {
          this.makeToast("danger", response.data, "Ocurrió un error!");
        }
      }
    },
    getCollaborator () {
      const collaboratorOptions = []
      this.users.forEach(user => {
        if(user.role === 'collaborator' || user.role === 'owner'){
          collaboratorOptions.push({
            text: user.name +' '+ user.lastName,
            value: user.id
          })
        }
      })
      return collaboratorOptions
    }
  },
  computed :{
    ...mapGetters('UserStore',['users'])
  },
  created(){
    this.listUsers()
  }
};
</script>